import Vue from 'vue'
import { MessageBox, Notification } from 'element-ui'

let isMsgOpen = false
function getMsgboxClassName (size) {
  if (!['sm', 'md', 'lg'].includes(size)) {
    return ''
  }
  return size
}

function mergeMsgboxOptions (options = {}) {
  const { size, customClass, ...rest } = options
  const sizeClassName = getMsgboxClassName(size)
  return {
    ...rest,
    customClass: [customClass, sizeClassName].filter(Boolean).join(' ')
  }
}

function normalizeMsgboxArgs (args) {
  if (!args.length) {
    return args
  }

  if (args.length === 1 && args[0] && typeof args[0] === 'object' && !Array.isArray(args[0])) {
    return [mergeMsgboxOptions(args[0])]
  }

  const lastArg = args[args.length - 1]
  if (lastArg && typeof lastArg === 'object' && !Array.isArray(lastArg)) {
    return [...args.slice(0, -1), mergeMsgboxOptions(lastArg)]
  }

  return args
}

function commonMsgbox (...args) {
  return MessageBox(...normalizeMsgboxArgs(args))
}

function createToast () {
  function toast (msg, options = {}) {
    const {
      offset,
      duration = 3000,
      position = 'center',
      showClose = false,
      dangerouslyUseHTMLString = true,
      customClass,
      onClick,
      onClose
    } = options

    Notification({
      message: msg,
      position,
      duration,
      showClose,
      customClass,
      dangerouslyUseHTMLString,
      onClick: typeof onClick === 'function'
        ? onClick
        : () => Notification.closeAll(),
      onClose
    })
  }

  toast.closeAll = function () {
    Notification.closeAll()
  }

  return toast
}

commonMsgbox.confirm = function (...args) {
  isMsgOpen = true
  const promise = MessageBox.confirm(...normalizeMsgboxArgs(args))
  promise.finally(() => {
    isMsgOpen = false
  })
  return promise
}

commonMsgbox.alert = function (...args) {
  isMsgOpen = true
  const promise = MessageBox.alert(...normalizeMsgboxArgs(args))
  promise.finally(() => {
    isMsgOpen = false
  })
  return promise
}

commonMsgbox.prompt = function (...args) {
  isMsgOpen = true
  const promise = MessageBox.prompt(...normalizeMsgboxArgs(args))
  promise.finally(() => {
    isMsgOpen = false
  })
  return promise
}

commonMsgbox.closeIfOpen = function () {
  if (isMsgOpen) {
    MessageBox.close()
  }
}

commonMsgbox.isMsgOpen = function () {
  return isMsgOpen
}

Vue.prototype.$createToast = createToast()
Vue.prototype.$msgbox = commonMsgbox
Vue.prototype.$alert = commonMsgbox.alert
Vue.prototype.$confirm = commonMsgbox.confirm
Vue.prototype.$prompt = commonMsgbox.prompt
Vue.prototype.$commonMsgbox = commonMsgbox
